import { useDispatch, useSelector } from "react-redux";
import { changeStatusBanners, onChangeIsEdit, onFetchBanners, onSetEditBanner, onSetOpenModal, onSetSelectedBanner, selectBannerState } from "../redux/slices/bannerSlice";
import { ApiStatus } from "../types/api/status";
import { BannerAPI } from "../apis/BannerAPI";
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar";
import { Banner, BannerCreateEdit } from "../types/slices/bannersType";

export const useBannerStore = () => {
  const dispatch = useDispatch();
  const {
    banners,
    statusBanners,
    editBanner,
    selectedBanner,
    openModal,
    isEdit,
  } = useSelector(selectBannerState);

  const getBanners = async () => {
    try {
      dispatch(changeStatusBanners(ApiStatus.FETCHING));
      const response = await BannerAPI.getBanners();
      if (!response?.status) {
        dispatch(changeStatusBanners(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      const { detail } = response.data;
      dispatch(onFetchBanners(detail));
      dispatch(changeStatusBanners(ApiStatus.FETCHED));
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusBanners(ApiStatus.FETCHED));
    }
  };

  const getBannersSearch = async (term) => {
    try {
      dispatch(changeStatusBanners(ApiStatus.FETCHING));
      const response = await BannerAPI.getBannersSearch(term);
      if (!response?.status) {
        dispatch(changeStatusBanners(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      const { detail } = response.data;
      dispatch(onFetchBanners(detail));
      dispatch(changeStatusBanners(ApiStatus.FETCHED));
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusBanners(ApiStatus.FETCHED));
    }
  };

  const createBannerStore = async (data: any) => {
    try {
      dispatch(changeStatusBanners(ApiStatus.FETCHING));
      const response = await BannerAPI.createBanner(data);
      if (!response?.status) {
        dispatch(changeStatusBanners(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      dispatch(changeStatusBanners(ApiStatus.FETCHED));
      CustomSnackbar("success", response.data.message || "");
      return true;
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusBanners(ApiStatus.FETCHED));
    }
  };

  const editBannerStore = async (id: number, data: any) => {
    try {
      dispatch(changeStatusBanners(ApiStatus.FETCHING));
      const response = await BannerAPI.editBanner(id, data);
      if (!response?.status) {
        dispatch(changeStatusBanners(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      dispatch(changeStatusBanners(ApiStatus.FETCHED));
      CustomSnackbar("success", response.data.message || "");
      return true;
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusBanners(ApiStatus.FETCHED));
    }
  };

  const deleteBanner = async (id: number) => {
    try {
      dispatch(changeStatusBanners(ApiStatus.FETCHING));
      const response = await BannerAPI.deleteBanner(id);
      if (!response?.status) {
        dispatch(changeStatusBanners(ApiStatus.FETCHED));
        CustomSnackbar("error", response.data.message || "");
        return false;
      }
      dispatch(changeStatusBanners(ApiStatus.FETCHED));
      CustomSnackbar("success", response.data.message || "");
      return true;
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusBanners(ApiStatus.FETCHED));
    }
  };

  const setSelectedBanner = (banner: Banner) => {
    try {
      dispatch(onSetSelectedBanner(banner));
    } catch (error) {
      console.log(error);
    }
  };

  const setEditBanner = (banner: BannerCreateEdit) => {
    try {
      dispatch(onSetEditBanner(banner));
    } catch (error) {
      console.log(error);
    }
  };

  const setOpenModal = (status: boolean) => {
    try {
      dispatch(onSetOpenModal(status));
    } catch (error) {
      console.log(error);
    }
  };

  const changeIsEdit = (status: boolean) => {
    try {
      dispatch(onChangeIsEdit(status));
    } catch (error) {
      console.log(error);
    }
  };

  return {
    // states
    banners,
    statusBanners,
    editBanner,
    selectedBanner,
    openModal,
    isEdit,
    // actions
    getBanners,
    getBannersSearch,
    createBannerStore,
    editBannerStore,
    deleteBanner,
    setOpenModal,
    setEditBanner,
    setSelectedBanner,
    changeIsEdit,
  };
};